import React from "react";
import { parseISO, format } from "date-fns";

export default function Date({ dateString }: { dateString: string | null }) {
  if (!dateString) {
    return null;
  }
  const date = parseISO(dateString);
  return <time dateTime={dateString}>{format(date, "HH:mm:ss")}</time>;
}
